import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Contact, Pencil } from "lucide-react";
import { cn } from "@/lib/utils";
import { ReferencesForm } from "./ReferencesForm";
import { formatPhoneNumber } from "@/common/utils/formatPhoneNumber";

type Reference = {
  index: number;
  value: unknown;
};
type ReferenceValue = {
  first_name?: string;
  last_name?: string;
  relationship_description?: string;
  email?: string;
  phone_number?: string;
};

export const ReferencesCard = ({
  editable,
  references,
  userId,
  onEditChange,
  isEditing,
}: {
  editable: boolean;
  references: Reference[];
  onEditChange: (editing: boolean) => void;
  isEditing: boolean;
  userId: string;
}) => {
  return (
    <Card
      className={cn("mt-4", {
        "shadow-none border-none": isEditing,
      })}
    >
      <CardHeader className="pb-1">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold">References</h3>
          {isEditing || !editable ? null : (
            <Button
              variant="ghost"
              size="icon"
              onClick={() => onEditChange(true)}
            >
              <Pencil className="h-4 w-4" />
            </Button>
          )}
        </div>
      </CardHeader>
      <CardContent className="space-y-2">
        {isEditing ? (
          <ReferencesForm
            references={references}
            userId={userId}
            onSave={() => onEditChange(false)}
          />
        ) : (
          <>
            {references.map((reference, index) => {
              const value = reference.value as ReferenceValue;
              return (
                <div key={index} className="space-y-2">
                  <div className="flex items-center gap-3">
                    <Contact className="h-5 w-5 text-gray-500" />
                    <div>
                      <div className="font-semibold">
                        {value.first_name} {value.last_name}
                      </div>
                      <div className="text-sm text-gray-600">
                        {value.relationship_description}
                      </div>
                      {value.phone_number && (
                        <div className="text-sm text-gray-500">
                          {formatPhoneNumber(value.phone_number)}
                        </div>
                      )}
                      <div className="text-sm text-gray-500">{value.email}</div>
                    </div>
                  </div>
                </div>
              );
            })}
            {references.length === 0 && (
              <div className="text-center text-gray-500">
                No references added yet.
              </div>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
};
